import React, { FC, PropsWithChildren } from 'react';

import { LinkWrapper } from '../links/LinkWrapper';
import {
  ButtonColor,
  PrimaryButton,
  PrimaryButtonProps,
} from './PrimaryButton';

export interface GetStartedButtonProps
  extends Omit<PrimaryButtonProps, 'buttonColor'> {
  buttonText?: string;
  onClick?: () => void;
  to?: string;
}

const Button: FC<PropsWithChildren<GetStartedButtonProps>> = ({
  children,
  ...rest
}) => (
  <PrimaryButton withCaret buttonColor={ButtonColor.Peach} {...rest}>
    {children}
  </PrimaryButton>
);

export const GetStartedButton: FC<GetStartedButtonProps> = ({
  buttonText = 'Get Started',
  onClick,
  to = '/welcome',
  ...rest
}) => {
  if (onClick) {
    return (
      <Button {...rest} onClick={onClick}>
        {buttonText}
      </Button>
    );
  }

  return (
    <LinkWrapper to={to}>
      <Button {...rest}>{buttonText}</Button>
    </LinkWrapper>
  );
};
